import React, { useState } from 'react';
import { LabelMedium } from './Typography';
import hexagonImage from '../images/hexagon_white.png';
import hexagonBorderImage from '../images/hexagon_white_border.png';
import hexagonDarkGreyImage from '../images/hexagon_darkgrey.png';

const PromptCard = ({ prompt, onClick, promptStatus }) => {
  const [isHovered, setIsHovered] = useState(false);

  // Get CTA text based on prompt status
  const getCTAText = () => {
    switch (promptStatus) {
      case 'completed':
        return 'Completed ✓';
      case 'active':
        return 'Jump Back In →';
      default:
        return 'Get Started →';
    }
  };

  // Get hexagon background based on prompt status
  const getHexagonBackground = () => {
    if (promptStatus === 'completed') {
      return hexagonDarkGreyImage;
    }
    return isHovered ? hexagonBorderImage : hexagonImage;
  };

  return (
    <button
      type="button"
      className="relative w-[430px] h-[344px] cursor-pointer transform hover:scale-105 transition-transform duration-200 focus:outline-none focus:ring-2 focus:ring-[#0A4872] focus:ring-offset-2 rounded-sm"
      onClick={() => onClick && onClick(prompt)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      aria-label={`${prompt.title}${prompt.category ? `, ${prompt.category}` : ''}${prompt.length ? `, ${prompt.length}` : ''}: ${getCTAText()}`}
    >
      {/* Hexagon background is decorative; card button label conveys the content */}
      <div className="absolute inset-0">
        <img 
          src={getHexagonBackground()} 
          alt=""
          role="presentation"
          className="w-full h-full object-contain"
        />
      </div>

      {/* Content */}
      <div className="absolute inset-0 flex flex-col justify-center items-center text-center p-12">
        {/* Category and Length Tags */}
        {(prompt.category || prompt.length) && (
          <div className="mb-3 flex flex-wrap gap-1 justify-center">
            {prompt.category && (
              <span className={`px-2 py-1 text-xs font-medium rounded-full ${
                promptStatus === 'completed' 
                  ? 'bg-white/20 text-white' 
                  : 'bg-blue-100 text-blue-800'
              }`}>
                {prompt.category}
              </span>
            )}
            {prompt.length && (
              <span className={`px-2 py-1 text-xs font-medium rounded-full ${
                promptStatus === 'completed' 
                  ? 'bg-white/20 text-white' 
                  : 'bg-green-100 text-green-800'
              }`}>
                {prompt.length}
              </span>
            )}
          </div>
        )}

        {/* Prompt Title */}
        <div className="mb-4 w-full px-4">
          <div className={`font-poppins text-[18px] font-bold leading-[1.2] break-words overflow-wrap-anywhere text-center ${
            promptStatus === 'completed' ? 'text-white' : 'text-[#091E42]'
          }`}>
            {prompt.title}
          </div>
        </div>

        {/* Call to Action */}
        <div>
          <LabelMedium className={promptStatus === 'completed' ? '!text-white' : '!text-[#091E42]'}>
            {getCTAText()}
          </LabelMedium>
        </div>
      </div>

    </button>
  );
};

export default PromptCard;
